import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { EditSquare, IsOpen } from '../../../components/Icon';
import { Button } from '../../../components/Buttons';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { initiateVehicleEdit, setNewVehicleValue, setVehicleProperties } from '../actions';
import {
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_PROPERTIES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  VEHICLE_DETAILS_SALESCARD,
} from '../constants';
import { selectNewVehicle } from '../selectors';
import { VehicleFinanceSalesPropertyList } from './CardFinanceSalesPropertyList';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import styles from './CardCarcollect.module.css';
import cn from 'classnames';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { hasPermissions } from '../../../utils/helpers/permissions';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { Cell, List, Row } from '../../../components/List';



const IconWrapper = styled.div`
  cursor: pointer;
  font-size: 22px;
  .icon-edit-square {
    color: #d9d9d9;
  }
`;

const STATE = {
  isOpen: false,
  isEditVehicle: false,
  values: null,
  isOpen: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCarcollectCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (hasPermissions(this.props.permissions, DEP_COMMERCE  )) {
      this.setState({ isOpen: true });
    }
    this.props.init();
    this.setState({ values: this.props.values });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.values?.id) {
      this.setState({ values: this.props.values });
    }
  }

  isShowPropertyCell(type) {
    let isShow = false;
    if (this.state.isEditVehicle || this.state.values[type] || this.props.values[type]) {
      isShow = true;
    }
    if (type === 'rest_bpm_export' && env.clientId == AppClientId.AUTOWIENTJES) {
      isShow = true
    }

    return isShow;
  }

  edit() {
    let properties = [];
    VEHICLE_DETAILS_SALESCARD.map(type => {
      // TODO: should be implemented on backend when value is '' or null
      // if (type == 'fix_damages_details' && !this.props.values[type] && this.props.vehicle[type]) {
      //   return properties.push({
      //     propertyName: type,
      //     propertyValue: ,
      //   });
      // }
      if (this.props.values[type]) {
        properties.push({
          propertyName: type,
          propertyValue: this.props.values[type],
        });
      }
    });

    this.props.patch(properties, callback => {
      this.setState({ values: this.props.values, isEditVehicle: false });
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  resetProps() {
    VEHICLE_DETAILS_SALESCARD.map(property => {
      if (this.props.vehicle[property]) {
        this.setState({ [property]: this.props.vehicle[property], isEditVehicle: false });
        this.props.setValue(this.props.vehicle[property], property);
        return;
      }
    });
    return this.setState({ isEditVehicle: false });
  }

  render() {
    const vehicle = this.props.values;
  
    if (this.props.work) return <LoadingDetailsPageCard />;
    if (this.props.values.id !== vehicle?.id) {
      return <LoadingDetailsPageCard />;
    }
    if (!this.state.values?.id) {
      return <LoadingDetailsPageCard />;
    }
  
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <HBox left className={styles.header}>
          <h2 className="card-title mb-0 text-muted" style={{ whiteSpace: 'nowrap' }}>
            {this.lbl('vehicle.info.finance.carcollect')} 
          </h2>
          <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>  
                <IsOpen />  
              </div> 
          {/* Render icons conditionally based on window width and isOpen state */}
          {this.state.isOpen && (
            <>
           
  
              {window.innerWidth <= 768 && (
                <>
                
  
                  <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                    <IsOpen />
                  </div>
                </>
              )}
            </>
          )}
        </HBox>
  
        {this.state.isOpen && (
          <>
           {}
           <List>
  {[
    "carcollect_status",
    "carcollect_fulfilment_intake",
    "carcollect_fulfilment_invoice",
    "carcollect_fulfilment_payment",
    "carcollect_fulfilment_document_handling",
    "carcollect_fulfilment_transport",
    "carcollect_auction_type",
    "carcollect_auction_start_date",
    "carcollect_auction_end_date",
    "carcollect_award_amount",
    "carcollect_award_branch_name",
    "carcollect_award_to_first_name",
    "carcollect_award_to_last_name"
  ].map(property => {
    let value = vehicle[property];

    // skip de hele rij als undefined of null
    if (value === undefined || value === null) return null;

    // format datumvelden NL
    if (
      property === "carcollect_auction_start_date" ||
      property === "carcollect_auction_end_date"
    ) {
      value = new Date(value).toLocaleString("nl-NL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    }
    // format bedrag
    else if (property === "carcollect_award_amount") {
      value = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    }
    // default vertaling

    
    else if (property === "carcollect_award_branch_name" || property === "carcollect_award_to_last_name" || property === "carcollect_award_to_first_name") {
      value = value;
    } 
    else {
      value = this.lbl(`vehicle.property.carcollect.${value}`);
    }

    return (
      <Row key={property}>
        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
        <Cell>{value}</Cell>
      </Row>
    );
  })}
</List>


            {this.state.isEditVehicle && (
              <div className="d-flex gap-2 mt-2">
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.resetProps.bind(this)}>
                  {this.lbl('cancel')}
                </ButtonComponent>
                &nbsp; &nbsp;
                <ButtonComponent style={'ButtonSoftEdit'} onClick={this.edit.bind(this)}>
                  {this.lbl('save')}
                </ButtonComponent>
              </div>
            )}
          </>
        )}
      </Card>
    );
  }}
  

  VehicleCarcollectCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE_PROPERTY_UPDATE, `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`]),
    values: selectNewVehicle(),
    permissions: selectPermissions(),


  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps.vehicle?.id, props, callback));
    },
    init() {
      dispatch(initiateVehicleEdit(ownProps.vehicle?.id));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCarcollectCard = compose(withConnect, withRouter)(VehicleCarcollectCardComp);
